if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"builder-runtime": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"h5/create/page":1,"vendors-node_modules_pnpm_arco-iconbox_react-hkgai-government-icon_0_0_61_react_18_2_0_node_m-d38584":1,"h5/detail/(id$)/page":1,"h5/meetings/page":1,"h5/mine/page":1,"h5/page":1,"h5/layout":1,"invite/page":1,"login/page":1,"vendors-node_modules_pnpm_milkdown_crepe_7_18_0_prosemirror-model_1_25_4_prosemirror-state_1_-dffda4":1,"src_views_meeting-assistant_index_tsx":1,"notebook/chat/history/page":1,"notebook/create/record/page":1,"notebook/create/transcribe/page":1,"notebook/create/upload/page":1,"src_views_meeting_list_index_scss":1,"notebook/cross-summary/page":1,"notebook/cross-summary-article/page":1,"vendors-node_modules_pnpm_arco-iconbox_react-hkgai-government-icon_0_0_61_react_18_2_0_node_m-c33f4e":1,"notebook/detail/(id$)/page":1,"notebook/hot-words/page":1,"notebook/page":1,"notebook/share/transcribe/(sessionId$)/page":1,"notebook/layout":1,"pwd/find/page":1,"pwd/reset/page":1,"reg/page":1,"test-markdown/page":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

var oldTags = [];
var newTags = [];
var applyHandler = (options) => {
	return { dispose: () => {
		for(var i = 0; i < oldTags.length; i++) {
			var oldTag = oldTags[i];
			if(oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
		}
		oldTags.length = 0;
	}, apply: () => {
		for(var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
		newTags.length = 0;
	} };
}
__webpack_require__.hmrC.miniCss = (chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) => {
	applyHandlers.push(applyHandler);
	chunkIds.forEach((chunkId) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if(!oldTag) return;
		promises.push(new Promise((resolve, reject) => {
			var tag = createStylesheet(chunkId, fullhref, oldTag, () => {
				tag.as = "style";
				tag.rel = "preload";
				resolve();
			}, reject);
			oldTags.push(oldTag);
			newTags.push(tag);
		}));
	});
}